import { Box, Divider, Stack, styled } from "@mui/material";

import { useContext } from "react";
import { useSelector } from "react-redux";

import { SidebarContext, widthMenuHide } from "@/contexts/SidebarContext";
import BreadcrumbsSidebar from "@/layouts/SidebarLayout/Header/Breadcrumbs";
import HeaderButtons from "@/layouts/SidebarLayout/Header/Buttons";
import HeaderUserbox from "@/layouts/SidebarLayout/Header/Userbox";
import { User } from "@/models/user";
import { rootReducerName } from "@/store/rootReducer";
import { useRouter } from "next/router";

type Props = {
  fullSize?: boolean;
};

type HeaderWrapperProps = {
  fullSize?: boolean;
  menuState: boolean;
};

const HeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "fullSize" && prop !== "menuState"
})<HeaderWrapperProps>(
  ({ theme, fullSize = false, menuState }) => `
          height: 50px;
          color: ${theme.header.textColor};
          z-index: 6;
          background-color: transparent;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          @media (min-width: ${theme.breakpoints.values.lg}px) {
              left: ${fullSize ? 0 : !menuState ? widthMenuHide : theme.sidebar.width};
              width: ${fullSize ? "100%" : !menuState ? `calc(100% - ${widthMenuHide})` : "auto"};
          }
  `
);

function HeaderMobile(props: Props) {
  const { getBreadcrumbsAndTitle, menuState } = useContext(SidebarContext);
  const { fullSize = false } = props;
  const router = useRouter();
  const user: User = useSelector((state) => state[rootReducerName.auth].user);
  const breadcrumbs = getBreadcrumbsAndTitle(router);

  return (
    <HeaderWrapper fullSize={fullSize} menuState={menuState} display="flex" alignItems="center">
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        width={"30%"}
        spacing={2}
      >
        {breadcrumbs.breadcrumbs.length > 0 && <BreadcrumbsSidebar breadcrumbs={breadcrumbs} />}
      </Stack>

      <Box display="flex" alignItems="center">
        <HeaderButtons />
        {user ? <HeaderUserbox /> : null}
      </Box>
    </HeaderWrapper>
  );
}

export default HeaderMobile;
